import React, { useEffect, useState } from "react";
import { X, Loader2 } from "lucide-react";
import { adminGet, formatApiError, resolveAssetUrl } from "../../lib/api";
import { toast } from "sonner";

const MediaPicker = ({ onSelect, onClose }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const d = await adminGet("/media");
        setItems(d.filter((m) => (m.content_type || "").startsWith("image/")));
      } catch (e) {
        toast.error(formatApiError(e));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="fixed inset-0 z-[110] bg-black/60 flex items-center justify-center p-4" data-testid="media-picker">
      <div className="bg-white max-w-4xl w-full max-h-[80vh] flex flex-col">
        <div className="bg-[#0A192F] text-white px-6 py-4 flex items-center justify-between">
          <h2 className="font-display font-bold uppercase tracking-widest text-sm">Select Image</h2>
          <button onClick={onClose} className="text-white/70 hover:text-white">
            <X size={18} />
          </button>
        </div>
        <div className="p-6 overflow-y-auto flex-1">
          {loading ? (
            <div className="flex items-center justify-center py-12 text-[#0A192F]/40">
              <Loader2 className="animate-spin mr-2" size={18} /> Loading…
            </div>
          ) : items.length === 0 ? (
            <div className="text-center py-12 text-[#0A192F]/60 text-sm">
              No images uploaded yet. Go to Media Library to upload first.
            </div>
          ) : (
            <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
              {items.map((m) => (
                <button
                  key={m.id}
                  onClick={() => onSelect(m.public_url)}
                  data-testid={`media-picker-item-${m.id}`}
                  className="aspect-square overflow-hidden bg-gray-100 border-2 border-transparent hover:border-[#D4AF37] transition-colors"
                >
                  <img src={resolveAssetUrl(m.public_url)} alt={m.filename} className="w-full h-full object-cover" />
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MediaPicker;
